export default "__VITE_ASSET__0GyHHYUDMCXrTySjUtrYKA__"